import { DocumentListView } from '@/components/documents/DocumentListView'

export default function InvoicesPage() {
  return <DocumentListView kind="invoice" />
}
